module.exports = __webpack_public_path__ + "static/media/debitor.de46f9ae.svg";